<template>
    <div>
        <template v-if="crud_designations_mapping === true">
            <div class="container">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h2 class="float-left">Add/Edit Designation(s) Mapping</h2>
                </div>
                <div class="global-main">
                    <form id="designationForm" @submit.prevent="submitDesignationMappingData">
                        <div class="tab-content-inner">
                            <div>
                                <div class="row" v-for="(item, index) in designations_mapping_rows" :key="index">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label class="label block-label"> Designation <em class="required">*</em></label>
                                            <select 
                                            data-none-selected-text="Select Designation" 
                                            v-model="form.designations_reportee[index]"
                                            name="designations_reportee[]" 
                                            class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('designations_reportee') }">
                                                <optgroup v-for="(departmentDesignations, departmentName) in departmentWiseDesignations" :label="departmentName" v-bind:key="departmentName">
                                                    <option v-for="designation in departmentDesignations" v-bind:value="designation.designation_id" v-bind:key="designation.designation_id">{{ designation.designation_name }}</option>
                                                </optgroup>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group text-center">
                                            <label class="label block-label mt-4 pt-3"> Reports To </label>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label class="label block-label"> Designation <em class="required">*</em></label>
                                            <select 
                                            data-none-selected-text="Select Designation" 
                                            v-model="form.designations_reporting[index]"
                                            name="designations_reporting[]" 
                                            class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('designations_reporting') }" multiple>
                                                <optgroup v-for="(departmentDesignations, departmentName) in departmentWiseDesignations" :label="departmentName" v-bind:key="departmentName">
                                                    <option v-for="designation in departmentDesignations" v-bind:value="designation.designation_id" v-bind:key="designation.designation_id">{{ designation.designation_name }}</option>
                                                </optgroup>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <button type="button" class="btn btn-success" @click="addRow">Add <i class="fas fa-plus-square"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/designations" class="btn btn-primary float-right mr-2">Cancel</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-if="crud_designations_mapping === null"><preLoader></preLoader></template>
        <template v-if="crud_designations_mapping === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mappingData: null,
                form: new Form({
                    designations_reportee: [],
                    designations_reporting: [],
                }),
                crud_designations_mapping: null,
                designations_mapping_rows: [], // number of dynamically added rows in html form
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_designations_mapping')
            .then(result => {
                this.$Progress.finish();
                this.crud_designations_mapping = result.crud_designations_mapping;
                if(this.crud_designations_mapping)
                {
                    this.getDepartmentWiseDesignations();                
                }
            })
            .catch(err => {
                console.log(err);
                this.$Progress.finish();
            });
        },
        methods: {
            getDepartmentWiseDesignations() 
            {
                this.$Progress.start();
                axios.post('/api/getDepartmentWiseDesignations')
                .then(res => {
                    if(res.data.code == 200)
                    {
                        this.departmentWiseDesignations = res.data.data.department_wise_designations;

                        this.getDesignationsMappingData(); 
                    }
                    else
                    {
                        this.showAlertBox('error','Some problem in fetching data for designations !');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Some problem in fetching data for designations !!');
                })
                .finally(()=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.finish();
                });
            },
            getDesignationsMappingData() 
            {
                this.$Progress.start();
                axios.post('/api/editDesignationsMappingData')
                .then(res => {
                    if(res.data.code == 200)
                    {
                        this.mappingData = res.data.data.mapping_data;

                        if(Object.keys(this.mappingData).length > 0)
                        {
                            for(let reporteeDesignation in this.mappingData)
                            {
                                let reportingDesignations = this.mappingData[ reporteeDesignation ];

                                this.designations_mapping_rows.push([]);

                                this.form.designations_reportee.push(reporteeDesignation);

                                this.form.designations_reporting.push(reportingDesignations);
                            }
                        }
                        else // if no mapping is already defined, add a row dynamically
                        { 
                            this.form.designations_reporting.push([]);  
                            this.designations_mapping_rows.push([]);    // at page load, push an empty array so that we can have at-least one-row in DOM
                        }
                    }
                    else
                    {
                        this.showAlertBox('error','Some problem in fetching mapping data !');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Some problem in fetching mapping data !!');
                })
                .finally(()=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.finish();
                });
            },
            addRow()
            {
                this.form.designations_reporting.push([]);
                this.designations_mapping_rows.push([]);

                // does not work without this quick fix 
                setTimeout(() => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                }, 100);
            },
            submitDesignationMappingData() {

                this.$Progress.start();

                this.form.post('api/addDesignationsMappingData')
                .then(res => {

                    if(res.data.code == 200)
                    {
                        this.showToastBox('success','Designation Mapping Added Successfully');
                    }
                    else
                    {
                        this.showAlertBox('error','Some problem in your form data !');
                    }

                    this.$Progress.finish();
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.finish();
                    this.showAlertBox('error','Some problem in your form data !!');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            }
        }
    }
</script>
